import React from 'react';
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import HomePage from "./HomePage";
import DatasetPage from "./DatasetPage";
import {config} from "./config";
// import notFound from "./NotFound";
// import NotFound from "./NotFound";

function App() {
    document.title = "Data Gov Corpus";
    return (
        <Router>
            <Routes>
                <Route path={config.web_prefix}>
                    <Route path="" element={<HomePage/>}/>
                    <Route path="dataset/:dataset_name" element={<DatasetPage />} />
                </Route>
                <Route path="*" element={<Navigate to={config.web_prefix} />}/>
            </Routes>
        </Router>
    );
}



export default App;
